import { CategoriesData, SubCategoriesData, TestData } from '../types';

export const transformCategory = (data: any): CategoriesData => {
  return {
    allTests: data.allTests,
    clinicalLaboratory: data.clinicalLaboratory,
    genetics: data.genetics,
    infectology: data.infectology,
    slug: data.slug,
    sortingNumber: data.sortingNumber,
    tests: data.tests,
    subCategories: data.subCategories,
    id: data.id,
    name: data.name
  };
};

export const transformSubCategory = (data: any): SubCategoriesData => {
  return {
    slug: '',
    tests: [],
    id: data.id,
    name: data.name
  };
};

export const transformTest = (data: any): TestData => {
  return {
    airportCovidTest: data.airportCovidTest,
    cardDescription: data.cardDescription,
    categoryId: data.categoryId,
    covidTestType: data.covidTestType,
    duration: data.duration,
    fullDescription: data.fullDescription,
    genicaCovidTest: data.genicaCovidTest,
    id: data.id,
    mobileLabCovidTest: data.mobileLabCovidTest,
    sortingNumber: data.sortingNumber,
    name: data.name,
    price: data.price,
    _draft: data._draft || false,
    sample: data.sample,
    slug: data.slug,
    subCategories: data.subCategories,
    subCategoryId: data.subCategoryId
  };
};
